jQuery(document).ready(function($){
$(document).on("click",".var_colr img",function() {
   var mmimg = $(this).attr('src');
    console.log(mmimg);
    $(".slider-nav .slick-list .slick-track .slick-slide").each(function() {
        var cimg = $(this).find('img').attr('src');
         console.log(cimg);
            if(mmimg == cimg)
            {
                console.log('yes');
                $(this).trigger('click');
            }
        else
            {
                 console.log('no');
            }
    });
});
  
var $swiperSelector = $('.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 60 ;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 5;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3.5;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 1.2;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        992: {
          slidesPerView: slidesTablet
        },
        320: {
           slidesPerView: slidesMobile
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true, 
      }
   });
});



  // Slick slider 


   var $slider = $('.slider-nav');
  var slideCount = $slider.children().length;  
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 11,
    slidesToScroll: 6,
    vertical:false,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:false,
    draggable: true,       
    swipe: true,           
    touchMove: true,    
    infinite: false,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
          draggable: true, 
          slidesToScroll: 6,
          verticalSwiping: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        slidesToShow: 7,
        draggable: true,
        swipe: true,
        touchMove: true, 
        dots: false,
        slidesToScroll: 6,
        verticalSwiping: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 6,
        draggable: true,
        swipe: true,
        touchMove: true, 
        dots: false,
        slidesToScroll: 5,
        verticalSwiping: false,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 5,
        draggable: true,
        swipe: true,
        touchMove: true, 
         dots: false,
        slidesToScroll: 4,
        verticalSwiping: false,
      }
    }
    ]
});

$('.slider-for').slickLightbox({
  itemSelector        : 'a',
  navigateByKeyboard  : true
});


// Slider for cart product

//   $('.js-slick-slide').slick({
//    slidesToShow: 1.4,
// 		slidesToScroll: 1,
// 		arrows: false,
// 		infinite: false, 
//      dots: false,
//       responsive: [
   
//     {
//       breakpoint: 767,
//       settings: {
//         vertical: false,
//         slidesToShow: 1.2,
//          dots: false,
//       }
//     }
//     ]
// });
	// $(".prev-btn").click(function () {
	// 	$(".js-slick-slide").slick("slickPrev");
	// });

	// $(".next-btn").click(function () {
	// 	$(".js-slick-slide").slick("slickNext");
	// });
  
	// $(".prev-btn").addClass("slick-disabled");
  
	// $(".js-slick-slide").on("afterChange", function () {
      
	// 	if ($(".slick-prev").hasClass("slick-disabled")) {
	// 		$(".prev-btn").addClass("slick-disabled");
	// 	} else {
	// 		$(".prev-btn").removeClass("slick-disabled");
	// 	}
	// 	if ($(".slick-next").hasClass("slick-disabled")) {
	// 		$(".next-btn").addClass("slick-disabled");
	// 	} else {
	// 		$(".next-btn").removeClass("slick-disabled");
	// 	}
	// });

 
  
});

function initCartSlider() {
    console.log("Initializing Slick Slider...");

    // Check if Slick is already initialized, then destroy it
    if ($('.js-slick-slide').hasClass('slick-initialized')) {
        $('.js-slick-slide').slick('unslick');
    }

    // Reinitialize Slick
    $('.js-slick-slide').slick({ 
        slidesToShow: 1.4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false, 
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    vertical: false,
                    slidesToShow: 1.2,
                    dots: false,
                }
            }
        ]
    });

    console.log("Slick Slider Reinitialized!");
  	$(".prev-btn").click(function () {
		$(".js-slick-slide").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".js-slick-slide").slick("slickNext");
	});
  
	$(".prev-btn").addClass("slick-disabled");
  
	$(".js-slick-slide").on("afterChange", function () {
      
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});

}

// Run when the page loads
$(document).ready(function () {
    initCartSlider();
});

$(document).on('click', ".product-form__submit, .cart-remove-button", function(){
   console.log("AJAX Complete: Checking Slick...");
    setTimeout(initCartSlider, 3000); // Wait for new content to load before initializing
});


$(document).on('blur', ".quantity__input", function(){
   console.log("AJAX quantiy: Checking Slick...");
    setTimeout(initCartSlider, 3000); // Wait for new content to load before initializing
});

// Run after AJAX updates the cart (when product is added/removed)
$(document).on('ajaxComplete', function () {
    console.log("AJAX Complete: Checking Slick...");
    
    setTimeout(initCartSlider, 300); // Wait for new content to load before initializing
});

